<template>
  <div class="convention-hall page">
    <van-nav-bar class="nav-bar" :title="$t('选妃')" />
    <div class="convention-item">
      <van-tabs :swipeable="true" animated line-width="100px" sticky>
        <van-tab :title="$t('城市大全')">
          <div class="card">
            {{ noticeHeader.text }}
          </div>
          <div class="address">
            <template v-for="(list, index) in addlist">
              <van-row
                v-for="(val, key) in list"
                class="address-item"
                @click="addgo(val)"
                :key="index + '-' + key"
                gutter="65"
              >
                {{ val.name }}
                <!--<van-col v-for="(v, k) in val" :key="k" offset="" span="" @click="addgo(v)">{{ v.name }}</van-col>-->
              </van-row>
            </template>
          </div>
        </van-tab>
        <van-tab :title="$t('流程价格')">
          <div class="card">
            {{ noticeHeader.text }}
          </div>
          <div class="rig-box">
            <div v-for="notice in noticeList" :key="notice.id">
              <p class="rig-title">{{ notice.name }}</p>
              <p class="rig-content">{{ notice.text }}</p>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      addlist: [],
      noticeHeader: {},
      noticeList: []
    }
  },
  methods: {
    addgo(data) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' })
      } else {
        this.$router.push({ path: '/list?id=' + data.id + '&name=' + data.name })
      }
    },
    getAddress() {
      this.$http({
        method: 'get',
        url: 'address_list'
      }).then((res) => {
        console.log('=>(index.vue:69) res.data', res.data)
        this.addlist = res.data
      })
    },
    getNoticeData() {
      const headerRequest = this.$http({
        method: 'get',
        url: 'sys_get_notice_list',
        data: { type: 3 }
      })

      const listRequest = this.$http({
        method: 'get',
        url: 'sys_get_notice_list',
        data: { type: 2 }
      })

      Promise.all([headerRequest, listRequest])
        .then(([headerRes, listRes]) => {
          this.noticeHeader = headerRes.data[0]
          this.noticeList = listRes.data
        })
        .catch((error) => {
          console.error('Error fetching notice data:', error)
        })
    }
  },
  created() {
    this.getAddress()
    this.getNoticeData()
  }
}
</script>

<style lang="less" scoped>
.convention-item {
  padding-bottom: 200px;
  background: #f2f2f5;
}
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f2f2f5;
}

.nav-bar {
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
  height: 100px;
}

.van-nav-bar {
  line-height: 50px;
}

::v-deep .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: #ffffff;
  font-size: 35px;
}

::v-deep .van-nav-bar__content {
  height: 100px;
}

.van-sidebar {
  width: 180px;
}

.convention-hall {
  display: flex;
  flex-direction: column;
  bottom: 20px;
  background: #f2f2f5;
}

::v-deep .van-tab {
  font-size: 30px;
  line-height: 100px;
  font-weight: bold;
}

::v-deep .van-tabs__line {
  background-color: #7e5678;
}

::v-deep .van-tabs--line .van-tabs__wrap {
  height: 100px;
}

::v-deep .van-tabs__wrap--scrollable .van-tab {
  padding: 0 23px;
}

.card {
  background-color: #8a637d;
  padding: 0.625rem;
  width: 95%;
  color: white;
  font-size: 0.8125rem;
  margin: 0.625rem auto;
  border-radius: 0.375rem;
}

::v-deep .van-row--flex {
  height: 80px;
  line-height: 80px;
}

.rig-box {
  width: 95%;
  margin: 0.625rem auto;
}

.rig-title {
  color: #0bdab0;
  font-size: 1.125rem;
}

.rig-content {
  font-size: 20px;
  // margin-top: 10px;
}

.address {
  border-radius: 4px;
  background-color: #fff;
  margin: 0.325rem 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.address-item {
  border-bottom: 1px solid #eee;
  padding: 18px 35px;
}
.address-item:last-child {
  border-bottom: none;
}
</style>
